var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    ref: "formPopup",
    attrs: {
      title: _vm.title,
      rightMethod: _vm.onSubmitted,
      rightButtonDisabled: _vm.isSubmitEEILoading || _vm.isWaitEeiLoading,
      rightButtonText: _vm.$t("submit"),
      isDisabledValidate: true,
      hasAlert: "",
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              { staticClass: "compact", attrs: { fluid: "" } },
              [
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            "hide-details": "",
                            items: _vm.labelTemplates,
                            "return-object": "",
                            label: _vm.$t("template"),
                            "item-text": "name"
                          },
                          on: { change: _vm.applyLabelTemplate },
                          model: {
                            value: _vm.selectedLabelTemplate,
                            callback: function($$v) {
                              _vm.selectedLabelTemplate = $$v
                            },
                            expression: "selectedLabelTemplate"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  {
                    staticClass: "title compact-layout",
                    attrs: { "align-baseline": "", "justify-space-between": "" }
                  },
                  [
                    _c(
                      "v-flex",
                      [
                        _c(
                          "v-card",
                          { attrs: { width: "100%" } },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "align-baseline": "" } },
                                  [
                                    _c("v-flex", { attrs: { xs3: "" } }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "electronicExportInformation"
                                            )
                                          ) +
                                          ":\n                "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs3: "" } },
                                      [
                                        _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              "offset-y": "",
                                              "close-on-content-click": false
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: "ITN",
                                                        "persistent-hint": "",
                                                        hint: _vm.$t(
                                                          "labelITNDesc"
                                                        ),
                                                        autocomplete:
                                                          "NoAutocomplete"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return on.click.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        }
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "append",
                                                            fn: function() {
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      color:
                                                                        "primary",
                                                                      small: "",
                                                                      flat: "",
                                                                      disabled: !_vm.itn
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.getAddressFromItn.apply(
                                                                          null,
                                                                          arguments
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "importInfo"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            },
                                                            proxy: true
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                      model: {
                                                        value: _vm.itn,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.itn = $$v
                                                        },
                                                        expression: "itn"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.menuItn,
                                              callback: function($$v) {
                                                _vm.menuItn = $$v
                                              },
                                              expression: "menuItn"
                                            }
                                          },
                                          [
                                            _vm._v(" "),
                                            _vm.recentItns &&
                                            _vm.recentItns.length
                                              ? _c(
                                                  "v-list",
                                                  _vm._l(
                                                    _vm.recentItns,
                                                    function(item) {
                                                      return _c(
                                                        "v-list-tile",
                                                        {
                                                          key: item.requestId,
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return function() {
                                                                return _vm.onSelectItn(
                                                                  item
                                                                )
                                                              }.apply(
                                                                null,
                                                                arguments
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-tile-content",
                                                            [
                                                              _c(
                                                                "v-list-tile-title",
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.requestId
                                                                    ) +
                                                                      " - " +
                                                                      _vm._s(
                                                                        item.itn ||
                                                                          "pending"
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs1: "" } },
                                      [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "div",
                                                      _vm._g({}, on),
                                                      [
                                                        _c("LoaderButton", {
                                                          attrs: {
                                                            buttonIcon: "",
                                                            flat: "",
                                                            promiseAwait:
                                                              _vm.getEeiStatus
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "icon",
                                                                fn: function() {
                                                                  return [
                                                                    _c(
                                                                      "v-icon",
                                                                      [
                                                                        _vm._v(
                                                                          "refresh"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                },
                                                                proxy: true
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ])
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t("getSelectedITN")
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs2: "" } },
                                      [
                                        _c("v-checkbox", {
                                          staticClass: "checkbox",
                                          attrs: {
                                            label: _vm.$t("commercialInvoice")
                                          },
                                          model: {
                                            value: _vm.isCommercialInvoice,
                                            callback: function($$v) {
                                              _vm.isCommercialInvoice = $$v
                                            },
                                            expression: "isCommercialInvoice"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { md6: "" } },
                      [
                        _c(
                          "v-card",
                          { attrs: { width: "100%" } },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "align-baseline": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "title",
                                        attrs: { md3: "" }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("sender")) + ": ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md4: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          attrs: {
                                            "hide-details": "",
                                            items: _vm.fromAddress,
                                            name: "address-template-name",
                                            "return-object": "",
                                            label: _vm.$t("addressName"),
                                            "item-text": "siteName",
                                            "item-value": "key"
                                          },
                                          model: {
                                            value: _vm.fromTemplate,
                                            callback: function($$v) {
                                              _vm.fromTemplate = $$v
                                            },
                                            expression: "fromTemplate"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md2: "" } },
                                      [
                                        _c("v-checkbox", {
                                          staticClass: "checkbox",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("save")
                                          },
                                          model: {
                                            value: _vm.isSaveFrom,
                                            callback: function($$v) {
                                              _vm.isSaveFrom = $$v
                                            },
                                            expression: "isSaveFrom"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.isSaveFrom
                                      ? _c(
                                          "v-flex",
                                          { attrs: { md3: "" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  flat: "",
                                                  color: "primary"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.toggleParseAddress(
                                                      "isShowFromParseAddress",
                                                      "parseFormAddress",
                                                      _vm.from
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("parseAddress"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _c(
                                          "v-flex",
                                          { attrs: { md3: "" } },
                                          [
                                            _vm.isSaveFrom
                                              ? _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t(
                                                      "addressName"
                                                    ),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "Site name"
                                                      ),
                                                      function(v) {
                                                        return v ===
                                                          _vm.to.siteName &&
                                                          _vm.isSaveTo
                                                          ? _vm.$t(
                                                              "siteNameIsSameAsToSite"
                                                            )
                                                          : true
                                                      }
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.from.siteName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "siteName",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "from.siteName"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.isShowFromParseAddress
                                  ? _c(
                                      "v-layout",
                                      [
                                        _c("v-textarea", {
                                          attrs: {
                                            label: _vm.$t("fullAddress"),
                                            outline: "",
                                            rows: "3",
                                            "hide-details": ""
                                          },
                                          model: {
                                            value: _vm.parseFormAddress,
                                            callback: function($$v) {
                                              _vm.parseFormAddress =
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                            },
                                            expression: "parseFormAddress"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("fullName"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "Full name"
                                                      ),
                                                      _vm.fieldCharLimit(
                                                        "Full name",
                                                        35
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.from.fullName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "fullName",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "from.fullName"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c(
                                                  "v-layout",
                                                  {
                                                    attrs: {
                                                      "justify-space-between":
                                                        ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      _vm._b(
                                                        {},
                                                        "v-flex",
                                                        {
                                                          xs7:
                                                            _vm
                                                              .currentShippingService
                                                              .isSupportFromExt,
                                                          xs12: !_vm
                                                            .currentShippingService
                                                            .isSupportFromExt
                                                        },
                                                        false
                                                      ),
                                                      [
                                                        _c("v-text-field", {
                                                          staticClass:
                                                            "required_field",
                                                          attrs: {
                                                            "hide-details": "",
                                                            rules: [
                                                              _vm.fieldIsRequired(
                                                                "Phone"
                                                              )
                                                            ],
                                                            label: _vm.$t(
                                                              "phone"
                                                            )
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.from.phone,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.from,
                                                                "phone",
                                                                typeof $$v ===
                                                                  "string"
                                                                  ? $$v.trim()
                                                                  : $$v
                                                              )
                                                            },
                                                            expression:
                                                              "from.phone"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.currentShippingService
                                                      .isSupportFromExt
                                                      ? _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { xs4: "" }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                "hide-details":
                                                                  "",
                                                                label: _vm.$t(
                                                                  "extension"
                                                                ),
                                                                rules: [
                                                                  _vm.fieldCharLimit(
                                                                    "extension",
                                                                    6
                                                                  )
                                                                ]
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.from
                                                                    .extension,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.from,
                                                                    "extension",
                                                                    typeof $$v ===
                                                                      "string"
                                                                      ? $$v.trim()
                                                                      : $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "from.extension"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            rules: [
                                              _vm.fieldCharRange(
                                                _vm.$t("companyName"),
                                                3,
                                                35
                                              )
                                            ],
                                            label: _vm.$t("companyName")
                                          },
                                          model: {
                                            value: _vm.from.company,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "company",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "from.company"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 1",
                                            rules: [
                                              _vm.fieldIsRequired("Address"),
                                              _vm.fieldCharLimit("Address1", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.from.address1,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "address1",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "from.address1"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 2",
                                            rules: [
                                              _vm.fieldCharLimit("Address2", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.from.address2,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "address2",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "from.address2"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("city"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "City"
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.from.city,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "city",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "from.city"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("vite-autocomplete", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    items: _vm.states,
                                                    label: _vm.$t("state"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "State"
                                                      )
                                                    ]
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "item",
                                                      fn: function(data) {
                                                        return [
                                                          [
                                                            _c(
                                                              "v-list-tile-content",
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  {
                                                                    attrs: {
                                                                      id:
                                                                        data.item
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                " +
                                                                        _vm._s(
                                                                          data.item
                                                                        ) +
                                                                        "\n                              "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        ]
                                                      }
                                                    }
                                                  ]),
                                                  model: {
                                                    value: _vm.from.state,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "state",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "from.state"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("zipCode"),
                                            rules: [
                                              _vm.fieldIsRequired("Zip code")
                                            ]
                                          },
                                          model: {
                                            value: _vm.from.zipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "zipCode",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "from.zipCode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c(
                                                  "v-layout",
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { xs3: "" } },
                                                      [
                                                        _c("v-select", {
                                                          attrs: {
                                                            "hide-details": "",
                                                            items: [
                                                              {
                                                                text: "EIN",
                                                                value: "E"
                                                              },
                                                              {
                                                                text: "SSN",
                                                                value: "S"
                                                              }
                                                            ]
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.fromPartyIdType,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.fromPartyIdType = $$v
                                                            },
                                                            expression:
                                                              "fromPartyIdType"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { xs9: "" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            "hide-details": "",
                                                            label: "EIN/SSN",
                                                            rules: [
                                                              _vm.partyIdValidator
                                                            ]
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.from.partyId,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.from,
                                                                "partyId",
                                                                typeof $$v ===
                                                                  "string"
                                                                  ? $$v.trim()
                                                                  : $$v
                                                              )
                                                            },
                                                            expression:
                                                              "from.partyId"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("email")
                                                  },
                                                  model: {
                                                    value: _vm.from.email,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "email",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "from.email"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          attrs: {
                                            "hide-details": "",
                                            items: [
                                              {
                                                name: _vm.$t("unitedStates"),
                                                value: "US"
                                              }
                                            ],
                                            "item-text": "name",
                                            "item-value": "value",
                                            label: _vm.$t("country")
                                          },
                                          model: {
                                            value: _vm.from.countryCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "countryCode",
                                                $$v
                                              )
                                            },
                                            expression: "from.countryCode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { md6: "" } },
                      [
                        _c(
                          "v-card",
                          { attrs: { width: "100%" } },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "align-baseline": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "title",
                                        attrs: { md3: "" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("recipient")) + ": "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md4: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          attrs: {
                                            "hide-details": "",
                                            items: _vm.addresses,
                                            "return-object": "",
                                            label: _vm.$t("addressName"),
                                            "item-text": "siteName",
                                            "item-value": "siteName"
                                          },
                                          model: {
                                            value: _vm.toTemplate,
                                            callback: function($$v) {
                                              _vm.toTemplate = $$v
                                            },
                                            expression: "toTemplate"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md2: "" } },
                                      [
                                        _c("v-checkbox", {
                                          staticClass: "checkbox",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("save")
                                          },
                                          model: {
                                            value: _vm.isSaveTo,
                                            callback: function($$v) {
                                              _vm.isSaveTo = $$v
                                            },
                                            expression: "isSaveTo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.isSaveTo
                                      ? _c(
                                          "v-flex",
                                          { attrs: { md3: "" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  flat: "",
                                                  color: "primary"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.toggleParseAddress(
                                                      "isShowToParseAddress",
                                                      "parseToAddress",
                                                      _vm.to
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("parseAddress"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _c(
                                          "v-flex",
                                          { attrs: { md3: "" } },
                                          [
                                            _vm.isSaveTo
                                              ? _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t(
                                                      "addressName"
                                                    ),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "Site name"
                                                      ),
                                                      function(v) {
                                                        return v ===
                                                          _vm.from.siteName &&
                                                          _vm.isSaveFrom
                                                          ? _vm.$t(
                                                              "siteNameIsSameAsToSite"
                                                            )
                                                          : true
                                                      }
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.to.siteName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "siteName",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.siteName"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.isShowToParseAddress
                                  ? _c(
                                      "v-layout",
                                      [
                                        _c("v-textarea", {
                                          attrs: {
                                            label: _vm.$t("fullAddress"),
                                            outline: "",
                                            rows: "3",
                                            "hide-details": ""
                                          },
                                          model: {
                                            value: _vm.parseToAddress,
                                            callback: function($$v) {
                                              _vm.parseToAddress =
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                            },
                                            expression: "parseToAddress"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("fullName"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "Full name"
                                                      ),
                                                      _vm.fieldCharLimit(
                                                        "Full name",
                                                        35
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.to.fullName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "fullName",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.fullName"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c(
                                                  "v-layout",
                                                  {
                                                    attrs: {
                                                      "justify-space-between":
                                                        ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      _vm._b(
                                                        {},
                                                        "v-flex",
                                                        {
                                                          xs7:
                                                            _vm
                                                              .currentShippingService
                                                              .isSupportToExt,
                                                          xs12: !_vm
                                                            .currentShippingService
                                                            .isSupportToExt
                                                        },
                                                        false
                                                      ),
                                                      [
                                                        _c("v-text-field", {
                                                          staticClass:
                                                            "required_field",
                                                          attrs: {
                                                            "hide-details": "",
                                                            label: _vm.$t(
                                                              "phone"
                                                            ),
                                                            rules: [
                                                              _vm.fieldIsRequired(
                                                                "Phone"
                                                              )
                                                            ]
                                                          },
                                                          model: {
                                                            value: _vm.to.phone,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.to,
                                                                "phone",
                                                                typeof $$v ===
                                                                  "string"
                                                                  ? $$v.trim()
                                                                  : $$v
                                                              )
                                                            },
                                                            expression:
                                                              "to.phone"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.currentShippingService
                                                      .isSupportToExt
                                                      ? _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { xs4: "" }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                "hide-details":
                                                                  "",
                                                                label: _vm.$t(
                                                                  "extension"
                                                                ),
                                                                rules: [
                                                                  _vm.fieldCharLimit(
                                                                    "extension",
                                                                    6
                                                                  )
                                                                ]
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.to
                                                                    .extension,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.to,
                                                                    "extension",
                                                                    typeof $$v ===
                                                                      "string"
                                                                      ? $$v.trim()
                                                                      : $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "to.extension"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            rules: [
                                              _vm.fieldCharRange(
                                                _vm.$t("companyName"),
                                                3,
                                                35
                                              )
                                            ],
                                            label: _vm.$t("companyName")
                                          },
                                          model: {
                                            value: _vm.to.company,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.to,
                                                "company",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "to.company"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 1",
                                            rules: [
                                              _vm.fieldIsRequired("Address"),
                                              _vm.fieldCharLimit("address", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.to.address1,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.to,
                                                "address1",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "to.address1"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 2",
                                            rules: [
                                              _vm.fieldCharLimit("Address2", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.to.address2,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.to,
                                                "address2",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "to.address2"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("city"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "City"
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.to.city,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "city",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.city"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("state")
                                                  },
                                                  model: {
                                                    value: _vm.to.state,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "state",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.state"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-around": "",
                                              "align-baseline": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("zipCode")
                                                  },
                                                  model: {
                                                    value: _vm.to.zipCode,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "zipCode",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.zipCode"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { top: "" },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.googleMapDisabled,
                                                                    icon: "",
                                                                    flat: "",
                                                                    color:
                                                                      "primary",
                                                                    small: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.goToGoogleMapLink.apply(
                                                                        null,
                                                                        arguments
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "location_on"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ])
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t("googleMap")
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c(
                                                  "v-layout",
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { xs3: "" } },
                                                      [
                                                        _c("v-select", {
                                                          attrs: {
                                                            "hide-details": "",
                                                            items: [
                                                              {
                                                                text: "EIN",
                                                                value: "E"
                                                              },
                                                              {
                                                                text: "SSN",
                                                                value: "S"
                                                              }
                                                            ]
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.toPartyIdType,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.toPartyIdType = $$v
                                                            },
                                                            expression:
                                                              "toPartyIdType"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { xs9: "" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            "hide-details": "",
                                                            label: "EIN/SSN"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.to.partyId,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.to,
                                                                "partyId",
                                                                typeof $$v ===
                                                                  "string"
                                                                  ? $$v.trim()
                                                                  : $$v
                                                              )
                                                            },
                                                            expression:
                                                              "to.partyId"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("email")
                                                  },
                                                  model: {
                                                    value: _vm.to.email,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "email",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.email"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            items: _vm.countryCodeArray,
                                            "item-text": "name",
                                            "item-value": "value",
                                            label: _vm.$t("country"),
                                            rules: [
                                              _vm.fieldIsRequired("Country")
                                            ]
                                          },
                                          model: {
                                            value: _vm.to.countryCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.to,
                                                "countryCode",
                                                $$v
                                              )
                                            },
                                            expression: "to.countryCode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.hasHazmatFeatures && _vm.isLabelServiceSupportDangerousGoods
                  ? _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-card",
                              { attrs: { width: "100%" } },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c("HazardousCommodities", {
                                      ref: "HazardousCommodities",
                                      attrs: {
                                        dangerousGoods: _vm.dangerousGoods,
                                        dryIceWeight: _vm.dryIceDetail.weight,
                                        dryIceUnit: _vm.dryIceDetail.unit,
                                        filterItems: ["", "LITHIUM_BATTERY"],
                                        isPrintSafetyDocument:
                                          _vm.isPrintSafetyDocument,
                                        signatureCode: _vm.signatureCode
                                      },
                                      on: {
                                        "update:dangerousGoods": function(
                                          $event
                                        ) {
                                          _vm.dangerousGoods = $event
                                        },
                                        "update:dangerous-goods": function(
                                          $event
                                        ) {
                                          _vm.dangerousGoods = $event
                                        },
                                        "update:dryIceWeight": function(
                                          $event
                                        ) {
                                          return _vm.$set(
                                            _vm.dryIceDetail,
                                            "weight",
                                            $event
                                          )
                                        },
                                        "update:dry-ice-weight": function(
                                          $event
                                        ) {
                                          return _vm.$set(
                                            _vm.dryIceDetail,
                                            "weight",
                                            $event
                                          )
                                        },
                                        "update:dryIceUnit": function($event) {
                                          return _vm.$set(
                                            _vm.dryIceDetail,
                                            "unit",
                                            $event
                                          )
                                        },
                                        "update:dry-ice-unit": function(
                                          $event
                                        ) {
                                          return _vm.$set(
                                            _vm.dryIceDetail,
                                            "unit",
                                            $event
                                          )
                                        },
                                        "update:isPrintSafetyDocument": function(
                                          $event
                                        ) {
                                          _vm.isPrintSafetyDocument = $event
                                        },
                                        "update:is-print-safety-document": function(
                                          $event
                                        ) {
                                          _vm.isPrintSafetyDocument = $event
                                        },
                                        "update:signatureCode": function(
                                          $event
                                        ) {
                                          _vm.signatureCode = $event
                                        },
                                        "update:signature-code": function(
                                          $event
                                        ) {
                                          _vm.signatureCode = $event
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-card",
                  { attrs: { width: "100%" } },
                  [
                    _c(
                      "v-card-text",
                      [
                        _c("EeiPackageWidget", {
                          ref: "EeiPackageWidget",
                          attrs: {
                            packages: _vm.packages,
                            noteMemoSignature: _vm.noteMemoSignature,
                            shipmentPurpose: _vm.shipmentPurpose,
                            shippingService: _vm.shippingService,
                            bookingConfirmationNumber:
                              _vm.bookingConfirmationNumber,
                            isAutoGetRate: true,
                            autoGetRateShippingService:
                              _vm.autoGetRateShippingService,
                            isGetRateAction: _vm.isGetRateAction,
                            dangerousGoods: _vm.dangerousGoods,
                            isEeiMode: _vm.isEeiMode
                          },
                          on: {
                            "update:packages": function($event) {
                              _vm.packages = $event
                            },
                            "update:shippingService": function($event) {
                              _vm.shippingService = $event
                            },
                            "update:shipping-service": function($event) {
                              _vm.shippingService = $event
                            },
                            changeAutoGetRate: function(e) {
                              return (_vm.isAutoGetRate = e)
                            },
                            selectTemplate: _vm.selectTemplate,
                            changeShippingService: _vm.changeShippingService,
                            clearDangerousGoods: _vm.clearDangerousGoods
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      [
                        _c(
                          "v-card",
                          { attrs: { width: "100%" } },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-layout",
                                  {
                                    staticClass: "title",
                                    attrs: {
                                      "align-baseline": "",
                                      "justify-space-between": ""
                                    }
                                  },
                                  [
                                    _c("v-flex", { attrs: { xs2: "" } }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t("billingDetails")) +
                                          ":\n                "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md2: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          attrs: {
                                            "hide-details": "",
                                            items: [
                                              {
                                                text: _vm.$t("sender"),
                                                value: "sender"
                                              }
                                            ],
                                            readonly: "",
                                            "item-value": "value",
                                            "item-text": "text",
                                            label: _vm.$t(
                                              "billingTransportationTo"
                                            )
                                          },
                                          model: {
                                            value: _vm.billingTransportationTo,
                                            callback: function($$v) {
                                              _vm.billingTransportationTo = $$v
                                            },
                                            expression:
                                              "billingTransportationTo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs2: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          attrs: {
                                            "hide-details": "",
                                            items: [
                                              {
                                                text: _vm.$t("recipient"),
                                                value: "RECIPIENT"
                                              }
                                            ],
                                            "item-value": "value",
                                            "item-text": "text",
                                            label: _vm.$t("dutiesPayor")
                                          },
                                          model: {
                                            value: _vm.dutiesPayor,
                                            callback: function($$v) {
                                              _vm.dutiesPayor = $$v
                                            },
                                            expression: "dutiesPayor"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-flex", { attrs: { xs2: "" } }),
                                    _vm._v(" "),
                                    _c("v-flex", { attrs: { xs2: "" } })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                !!_vm.isFedexCarrier
                  ? _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-card",
                              { attrs: { width: "100%" } },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        staticClass: "title",
                                        staticStyle: { "min-height": "56px" },
                                        attrs: {
                                          "align-baseline": "",
                                          "justify-space-between": ""
                                        }
                                      },
                                      [
                                        _c("v-flex", { attrs: { xs1: "" } }, [
                                          _vm._v(
                                            "\n                  ETD:\n                "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { grow: "" } },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                staticClass:
                                                  "etd-checkbox-container",
                                                attrs: { "align-center": "" }
                                              },
                                              [
                                                _c("v-checkbox", {
                                                  staticClass: "checkbox",
                                                  attrs: {
                                                    label: _vm.$t("ETDLabel"),
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value: _vm.isEnabledETD,
                                                    callback: function($$v) {
                                                      _vm.isEnabledETD = $$v
                                                    },
                                                    expression: "isEnabledETD"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: {
                                                      top: "",
                                                      "max-width": "300px"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "activator" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticStyle: {
                                                              cursor: "pointer"
                                                            },
                                                            attrs: {
                                                              small: "",
                                                              color: "primary"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          help_outline\n                        "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "white-space":
                                                            "normal",
                                                          "line-height": "1.4"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t("ETDInfo")
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-flex", {
                                          attrs: { md8: "", xs8: "" }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { staticClass: "compact-layout", attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      [
                        _c(
                          "v-form",
                          { ref: "commodityForm" },
                          [
                            !_vm.isEnableEEI
                              ? _c(
                                  "v-card",
                                  {
                                    staticClass: "compact-card",
                                    attrs: { width: "100%" }
                                  },
                                  [
                                    _c(
                                      "v-card-text",
                                      { staticClass: "compact-card-text" },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            staticClass: "title compact-layout",
                                            attrs: {
                                              "align-baseline": "",
                                              "justify-start": ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t("commodityInfo")
                                                ) +
                                                ":\n                  "
                                            ),
                                            !_vm.isCommodityUnchangeable
                                              ? _c(
                                                  "v-flex",
                                                  {
                                                    attrs: {
                                                      xs3: "",
                                                      "ml-4": ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-layout",
                                                      [
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { xs6: "" }
                                                          },
                                                          [
                                                            _c("v-combobox", {
                                                              attrs: {
                                                                "hide-details":
                                                                  "",
                                                                label: _vm.$t(
                                                                  "commodityTemplate"
                                                                ),
                                                                items:
                                                                  _vm.commodityTemplates,
                                                                "item-text":
                                                                  "name",
                                                                "item-value":
                                                                  "key",
                                                                clearable: ""
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.onSelectCommodityTemplate
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { xs4: "" }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              ref:
                                                                "newTemplateNameInput",
                                                              attrs: {
                                                                "hide-details":
                                                                  "",
                                                                label: _vm.$t(
                                                                  "newTemplateName"
                                                                )
                                                              },
                                                              on: {
                                                                keyup: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    !$event.type.indexOf(
                                                                      "key"
                                                                    ) &&
                                                                    _vm._k(
                                                                      $event.keyCode,
                                                                      "enter",
                                                                      13,
                                                                      $event.key,
                                                                      "Enter"
                                                                    )
                                                                  ) {
                                                                    return null
                                                                  }
                                                                  return _vm.saveCommodityTemplate.apply(
                                                                    null,
                                                                    arguments
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.newTemplateName,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.newTemplateName =
                                                                    typeof $$v ===
                                                                    "string"
                                                                      ? $$v.trim()
                                                                      : $$v
                                                                },
                                                                expression:
                                                                  "newTemplateName"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { xs2: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "v-tooltip",
                                                              {
                                                                attrs: {
                                                                  top: ""
                                                                },
                                                                scopedSlots: _vm._u(
                                                                  [
                                                                    {
                                                                      key:
                                                                        "activator",
                                                                      fn: function(
                                                                        ref
                                                                      ) {
                                                                        var on =
                                                                          ref.on
                                                                        return [
                                                                          _c(
                                                                            "v-btn",
                                                                            _vm._g(
                                                                              {
                                                                                attrs: {
                                                                                  icon:
                                                                                    "",
                                                                                  loading:
                                                                                    _vm.isSavingTemplate,
                                                                                  disabled:
                                                                                    _vm.isSavingTemplate
                                                                                },
                                                                                on: {
                                                                                  click:
                                                                                    _vm.saveCommodityTemplate
                                                                                }
                                                                              },
                                                                              on
                                                                            ),
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                [
                                                                                  _vm._v(
                                                                                    "save"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ]
                                                                      }
                                                                    }
                                                                  ],
                                                                  null,
                                                                  false,
                                                                  2525008650
                                                                )
                                                              },
                                                              [
                                                                _vm._v(" "),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "saveAsTemplate"
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.commodityErrorMessage
                                              ? _c(
                                                  "v-flex",
                                                  {
                                                    staticClass:
                                                      "red--text font-weight-bold text-xs-right"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.commodityErrorMessage
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-data-table", {
                                          staticClass: "elevation-2 mt-2",
                                          attrs: {
                                            headers: _vm.commodityHeaders,
                                            items: _vm.commodities,
                                            "hide-actions": ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "headerCell",
                                                fn: function(props) {
                                                  return [
                                                    props.header.value ===
                                                    "action"
                                                      ? _c(
                                                          "span",
                                                          [
                                                            _c(
                                                              "v-tooltip",
                                                              {
                                                                attrs: {
                                                                  top: ""
                                                                },
                                                                scopedSlots: _vm._u(
                                                                  [
                                                                    {
                                                                      key:
                                                                        "activator",
                                                                      fn: function(
                                                                        tooltip
                                                                      ) {
                                                                        return [
                                                                          _c(
                                                                            "div",
                                                                            _vm._g(
                                                                              {},
                                                                              tooltip.on
                                                                            ),
                                                                            [
                                                                              _c(
                                                                                "v-btn",
                                                                                {
                                                                                  attrs: {
                                                                                    color:
                                                                                      "primary",
                                                                                    flat:
                                                                                      "",
                                                                                    small:
                                                                                      "",
                                                                                    icon:
                                                                                      "",
                                                                                    disabled:
                                                                                      _vm.isCommodityUnchangeable
                                                                                  },
                                                                                  on: {
                                                                                    click:
                                                                                      _vm.addEmptyCommodity
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    [
                                                                                      _vm._v(
                                                                                        "add"
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ]
                                                                      }
                                                                    }
                                                                  ],
                                                                  null,
                                                                  true
                                                                )
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "add"
                                                                      )
                                                                    ) +
                                                                    "\n                      "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.header.text
                                                            )
                                                          )
                                                        ])
                                                  ]
                                                }
                                              },
                                              {
                                                key: "items",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "tr",
                                                      {
                                                        staticClass:
                                                          "commodity-row",
                                                        class: {
                                                          editing:
                                                            _vm.editingRowIndex ===
                                                            props.index
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.editRow(
                                                              props.index,
                                                              $event
                                                            )
                                                          },
                                                          mouseleave:
                                                            _vm.onRowMouseLeave
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-center"
                                                          },
                                                          [
                                                            _c(
                                                              "v-tooltip",
                                                              {
                                                                attrs: {
                                                                  top: ""
                                                                },
                                                                scopedSlots: _vm._u(
                                                                  [
                                                                    {
                                                                      key:
                                                                        "activator",
                                                                      fn: function(
                                                                        ref
                                                                      ) {
                                                                        var on =
                                                                          ref.on
                                                                        return [
                                                                          _c(
                                                                            "v-btn",
                                                                            _vm._g(
                                                                              {
                                                                                attrs: {
                                                                                  color:
                                                                                    "error",
                                                                                  flat:
                                                                                    "",
                                                                                  small:
                                                                                    "",
                                                                                  icon:
                                                                                    "",
                                                                                  disabled:
                                                                                    _vm
                                                                                      .commodities
                                                                                      .length ===
                                                                                      1 ||
                                                                                    _vm.isCommodityUnchangeable
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.deleteCommodity(
                                                                                      props.index
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              on
                                                                            ),
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                [
                                                                                  _vm._v(
                                                                                    "delete"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ]
                                                                      }
                                                                    }
                                                                  ],
                                                                  null,
                                                                  true
                                                                )
                                                              },
                                                              [
                                                                _vm._v(" "),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "delete"
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _c(
                                                              "v-layout",
                                                              {
                                                                attrs: {
                                                                  row: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-autocomplete",
                                                                  {
                                                                    staticClass:
                                                                      "table-item",
                                                                    staticStyle: {
                                                                      "max-width":
                                                                        "200px"
                                                                    },
                                                                    attrs: {
                                                                      value:
                                                                        props
                                                                          .item
                                                                          .selectedCommodity,
                                                                      items:
                                                                        _vm.mergedCommoditiesList,
                                                                      "item-text":
                                                                        "scheduleBDescription",
                                                                      "item-value":
                                                                        "scheduleBDescription",
                                                                      clearable:
                                                                        "",
                                                                      label: _vm.$t(
                                                                        "commodity"
                                                                      ),
                                                                      placeholder: _vm.$t(
                                                                        "commodities"
                                                                      ),
                                                                      rules: [
                                                                        _vm.fieldIsRequired(
                                                                          _vm.$t(
                                                                            "commodity"
                                                                          )
                                                                        )
                                                                      ],
                                                                      disabled:
                                                                        _vm.editingRowIndex !==
                                                                          props.index ||
                                                                        _vm.isCommodityUnchangeable,
                                                                      "return-object":
                                                                        ""
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.onComboboxChangeByCommodities(
                                                                          $event,
                                                                          props.index
                                                                        )
                                                                      },
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.onComboboxChangeByCommodities(
                                                                          $event,
                                                                          props.index
                                                                        )
                                                                      }
                                                                    },
                                                                    scopedSlots: _vm._u(
                                                                      [
                                                                        {
                                                                          key:
                                                                            "item",
                                                                          fn: function(
                                                                            data
                                                                          ) {
                                                                            return [
                                                                              _c(
                                                                                "v-list-tile-content",
                                                                                {
                                                                                  staticStyle: {
                                                                                    "max-width":
                                                                                      "300px",
                                                                                    "white-space":
                                                                                      "normal"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-list-tile-title",
                                                                                    {
                                                                                      staticStyle: {
                                                                                        "white-space":
                                                                                          "normal",
                                                                                        "word-wrap":
                                                                                          "break-word"
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          data
                                                                                            .item
                                                                                            .scheduleBDescription ||
                                                                                            data
                                                                                              .item
                                                                                              .description
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "v-list-tile-sub-title",
                                                                                    {
                                                                                      staticStyle: {
                                                                                        "white-space":
                                                                                          "normal",
                                                                                        "word-wrap":
                                                                                          "break-word"
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                Code: " +
                                                                                          _vm._s(
                                                                                            data
                                                                                              .item
                                                                                              .scheduleBCode
                                                                                          ) +
                                                                                          "\n                              "
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          }
                                                                        },
                                                                        {
                                                                          key:
                                                                            "no-data",
                                                                          fn: function() {
                                                                            return [
                                                                              _c(
                                                                                "v-list-tile",
                                                                                [
                                                                                  _c(
                                                                                    "v-list-tile-content",
                                                                                    [
                                                                                      _c(
                                                                                        "v-list-tile-title",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "\n                                  " +
                                                                                              _vm._s(
                                                                                                _vm.$t(
                                                                                                  "noDataAvailable"
                                                                                                )
                                                                                              ) +
                                                                                              "\n                                "
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          },
                                                                          proxy: true
                                                                        }
                                                                      ],
                                                                      null,
                                                                      true
                                                                    )
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    staticClass:
                                                                      "table-item",
                                                                    staticStyle: {
                                                                      "max-width":
                                                                        "250px"
                                                                    },
                                                                    attrs: {
                                                                      label: _vm.$t(
                                                                        "description"
                                                                      ),
                                                                      placeholder: _vm.$t(
                                                                        "description"
                                                                      ),
                                                                      rules: [
                                                                        _vm.fieldIsRequired(
                                                                          _vm.$t(
                                                                            "description"
                                                                          )
                                                                        ),
                                                                        _vm.fieldCharLimit(
                                                                          "description",
                                                                          35
                                                                        )
                                                                      ],
                                                                      disabled:
                                                                        _vm.editingRowIndex !==
                                                                        props.index
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        props
                                                                          .item
                                                                          .scheduleBDescription,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          props.item,
                                                                          "scheduleBDescription",
                                                                          typeof $$v ===
                                                                            "string"
                                                                            ? $$v.trim()
                                                                            : $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "props.item.scheduleBDescription"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _c(
                                                              "v-layout",
                                                              {
                                                                attrs: {
                                                                  row: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-autocomplete",
                                                                  {
                                                                    staticClass:
                                                                      "table-item required_field",
                                                                    attrs: {
                                                                      items:
                                                                        _vm.countryCodeArray,
                                                                      label: _vm.$t(
                                                                        "countryOfOrigin"
                                                                      ),
                                                                      "item-text":
                                                                        "name",
                                                                      "item-value":
                                                                        "value",
                                                                      rules: [
                                                                        _vm.fieldIsRequired(
                                                                          _vm.$t(
                                                                            "countryOfOrigin"
                                                                          )
                                                                        )
                                                                      ],
                                                                      disabled:
                                                                        _vm.editingRowIndex !==
                                                                          props.index ||
                                                                        (_vm.isCommodityUnchangeable &&
                                                                          props
                                                                            .item
                                                                            .countryOfOrigin ===
                                                                            "US")
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        props
                                                                          .item
                                                                          .countryOfOrigin,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          props.item,
                                                                          "countryOfOrigin",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "props.item.countryOfOrigin"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    staticClass:
                                                                      "table-item required_field",
                                                                    class: {
                                                                      required_field: _vm.isHsCodeRequired(
                                                                        props.item
                                                                      )
                                                                    },
                                                                    attrs: {
                                                                      rules: [
                                                                        _vm.validateHsCode
                                                                      ],
                                                                      disabled:
                                                                        _vm.editingRowIndex !==
                                                                        props.index
                                                                    },
                                                                    on: {
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.onHarmonizedCodeInput(
                                                                          props.item
                                                                        )
                                                                      }
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        props
                                                                          .item
                                                                          .harmonizedCode,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          props.item,
                                                                          "harmonizedCode",
                                                                          typeof $$v ===
                                                                            "string"
                                                                            ? $$v.trim()
                                                                            : $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "props.item.harmonizedCode"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _c(
                                                              "v-text-field",
                                                              {
                                                                staticClass:
                                                                  "required_field pt-0 table-item qty_unit_filed",
                                                                attrs: {
                                                                  rules: [
                                                                    _vm.fieldIsRequired(),
                                                                    _vm.fieldIsInteger(),
                                                                    _vm.fieldIsOverZero()
                                                                  ],
                                                                  label: _vm.$t(
                                                                    "quantity"
                                                                  ),
                                                                  disabled:
                                                                    _vm.editingRowIndex !==
                                                                      props.index ||
                                                                    _vm.isCommodityUnchangeable
                                                                },
                                                                on: {
                                                                  input: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.onQuantityInput(
                                                                      props.item
                                                                    )
                                                                  }
                                                                },
                                                                nativeOn: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                  }
                                                                },
                                                                model: {
                                                                  value:
                                                                    props.item
                                                                      .quantity,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.item,
                                                                      "quantity",
                                                                      _vm._n(
                                                                        $$v
                                                                      )
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "props.item.quantity"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "template",
                                                                  {
                                                                    slot:
                                                                      "append-outer"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-autocomplete",
                                                                      {
                                                                        staticClass:
                                                                          "qty_unit required_field",
                                                                        attrs: {
                                                                          items: _vm.getCommodityUnitItems(
                                                                            props.item
                                                                          ),
                                                                          rules: [
                                                                            _vm.fieldIsRequired(
                                                                              _vm.$t(
                                                                                "unit"
                                                                              )
                                                                            )
                                                                          ],
                                                                          "item-text":
                                                                            "text",
                                                                          "item-value":
                                                                            "key",
                                                                          label: _vm.$t(
                                                                            "unit"
                                                                          ),
                                                                          disabled:
                                                                            _vm.editingRowIndex !==
                                                                              props.index ||
                                                                            _vm.isCommodityUnchangeable
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            props
                                                                              .item
                                                                              .selectedUnit,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              props.item,
                                                                              "selectedUnit",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "props.item.selectedUnit"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              2
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.hasCommodityQty2
                                                          ? _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-xs-left"
                                                              },
                                                              [
                                                                _vm.isShowQty2(
                                                                  props.item
                                                                )
                                                                  ? _c(
                                                                      "v-text-field",
                                                                      {
                                                                        staticClass:
                                                                          "required_field pt-0 table-item qty_unit_filed",
                                                                        attrs: {
                                                                          rules: [
                                                                            _vm.fieldIsRequired(),
                                                                            _vm.fieldIsInteger(),
                                                                            _vm.fieldIsOverZero()
                                                                          ],
                                                                          label: _vm.$t(
                                                                            "quantity"
                                                                          ),
                                                                          disabled:
                                                                            _vm.editingRowIndex !==
                                                                            props.index
                                                                        },
                                                                        nativeOn: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                          }
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            props
                                                                              .item
                                                                              .quantity2,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              props.item,
                                                                              "quantity2",
                                                                              _vm._n(
                                                                                $$v
                                                                              )
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "props.item.quantity2"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "template",
                                                                          {
                                                                            slot:
                                                                              "append-outer"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-autocomplete",
                                                                              {
                                                                                staticClass:
                                                                                  "qty_unit required_field",
                                                                                attrs: {
                                                                                  items:
                                                                                    _vm.inShowUnit2List,
                                                                                  rules: [
                                                                                    _vm.fieldIsRequired(
                                                                                      _vm.$t(
                                                                                        "unit"
                                                                                      )
                                                                                    )
                                                                                  ],
                                                                                  "item-text":
                                                                                    "text",
                                                                                  "item-value":
                                                                                    "key",
                                                                                  label: _vm.$t(
                                                                                    "unit"
                                                                                  ),
                                                                                  disabled:
                                                                                    _vm.editingRowIndex !==
                                                                                    props.index
                                                                                },
                                                                                model: {
                                                                                  value:
                                                                                    props
                                                                                      .item
                                                                                      .quantity2Units,
                                                                                  callback: function(
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      props.item,
                                                                                      "quantity2Units",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                  expression:
                                                                                    "props.item.quantity2Units"
                                                                                }
                                                                              }
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      2
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                !_vm.isShowQty2(
                                                                  props.item
                                                                )
                                                                  ? _c(
                                                                      "v-text-field",
                                                                      {
                                                                        staticClass:
                                                                          "required_field pt-0 table-item qty_unit_filed",
                                                                        attrs: {
                                                                          rules: [
                                                                            _vm.fieldIsRequired(),
                                                                            _vm.fieldIsInteger(),
                                                                            _vm.fieldIsOverZero()
                                                                          ],
                                                                          label: _vm.$t(
                                                                            "quantity"
                                                                          ),
                                                                          disabled:
                                                                            ""
                                                                        },
                                                                        nativeOn: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "template",
                                                                          {
                                                                            slot:
                                                                              "append-outer"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-autocomplete",
                                                                              {
                                                                                staticClass:
                                                                                  "qty_unit required_field",
                                                                                attrs: {
                                                                                  items:
                                                                                    _vm.inShowUnit2List,
                                                                                  rules: [
                                                                                    _vm.fieldIsRequired(
                                                                                      _vm.$t(
                                                                                        "unit"
                                                                                      )
                                                                                    )
                                                                                  ],
                                                                                  "item-text":
                                                                                    "text",
                                                                                  "item-value":
                                                                                    "key",
                                                                                  disabled:
                                                                                    "",
                                                                                  label: _vm.$t(
                                                                                    "unit"
                                                                                  )
                                                                                }
                                                                              }
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      2
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              staticClass:
                                                                "table-item required_field",
                                                              attrs: {
                                                                label: _vm.$t(
                                                                  "price"
                                                                ),
                                                                prefix: "$",
                                                                rules: [
                                                                  _vm.fieldIsRequired(
                                                                    _vm.$t(
                                                                      "price"
                                                                    )
                                                                  ),
                                                                  _vm.fieldIsOverZero(
                                                                    _vm.$t(
                                                                      "price"
                                                                    )
                                                                  )
                                                                ],
                                                                disabled:
                                                                  _vm.editingRowIndex !==
                                                                    props.index ||
                                                                  _vm.isCommodityUnchangeable
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.onPriceInput(
                                                                    props.item
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  props.item
                                                                    .price,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    props.item,
                                                                    "price",
                                                                    _vm._n($$v)
                                                                  )
                                                                },
                                                                expression:
                                                                  "props.item.price"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              staticClass:
                                                                "table-item required_field",
                                                              attrs: {
                                                                label: _vm.$t(
                                                                  "customsValue"
                                                                ),
                                                                value:
                                                                  props.item
                                                                    .customsValue,
                                                                prefix: "$",
                                                                disabled: true
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              staticClass:
                                                                "table-item required_field",
                                                              attrs: {
                                                                label: _vm.$t(
                                                                  "weight"
                                                                ),
                                                                suffix: _vm.isMeasurementMetric
                                                                  ? "kg"
                                                                  : "Lbs",
                                                                rules: [
                                                                  _vm.fieldIsRequired(
                                                                    _vm.$t(
                                                                      "weight"
                                                                    )
                                                                  ),
                                                                  _vm.fieldIsOverZero(
                                                                    _vm.$t(
                                                                      "weight"
                                                                    )
                                                                  )
                                                                ],
                                                                disabled:
                                                                  _vm.editingRowIndex !==
                                                                    props.index ||
                                                                  _vm.isCommodityUnchangeable
                                                              },
                                                              model: {
                                                                value:
                                                                  props.item
                                                                    .commodityWeight,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    props.item,
                                                                    "commodityWeight",
                                                                    _vm._n($$v)
                                                                  )
                                                                },
                                                                expression:
                                                                  "props.item.commodityWeight"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            3160287053
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { staticClass: "compact-layout", attrs: { column: "" } },
                  [
                    _c(
                      "v-flex",
                      [
                        _c(
                          "v-layout",
                          {
                            attrs: { "justify-end": "", "align-baseline": "" }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "mb-2 font-weight-bold text-xs-right",
                                staticStyle: {
                                  "font-size": "16px",
                                  "background-color": "yellow"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Rate does not include duties & taxes, clearance entry fees or other import fees.\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { xs7: "" } },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "align-baseline": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { md2: "" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { color: "primary" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.getRate.apply(
                                                  null,
                                                  arguments
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("getRate")))]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.isAutoGetRate
                                      ? _c(
                                          "v-flex",
                                          { attrs: { md3: "", "mr-5": "" } },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "selectedShippingService"
                                                  ) + ": "
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-weight-black"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.displayRate
                                                      .serviceDescription
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md9: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          [
                                            _vm.isLoadingRates
                                              ? _c(
                                                  "v-flex",
                                                  { attrs: { md2: "" } },
                                                  [
                                                    _c("v-progress-circular", {
                                                      attrs: {
                                                        indeterminate: "",
                                                        color: "primary"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "v-flex",
                                                  { attrs: { md10: "" } },
                                                  [
                                                    _c(
                                                      "v-layout",
                                                      {
                                                        attrs: {
                                                          row: "",
                                                          "no-wrap": "",
                                                          "text-xs-center": ""
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "baseCharge"
                                                              )
                                                            ) +
                                                            ": $\n                        "
                                                        ),
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { top: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "activator",
                                                                  fn: function(
                                                                    tooltip
                                                                  ) {
                                                                    return [
                                                                      _c(
                                                                        "span",
                                                                        _vm._g(
                                                                          {},
                                                                          tooltip.on
                                                                        ),
                                                                        [
                                                                          _vm._v(
                                                                            "\n                              " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .displayRate
                                                                                  .rate ||
                                                                                  "----"
                                                                              ) +
                                                                              "\n                            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ]
                                                            )
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm
                                                                    .displayRate
                                                                    .originBaseCharge
                                                                    ? Math.round(
                                                                        (100 *
                                                                          (_vm
                                                                            .displayRate
                                                                            .originBaseCharge -
                                                                            _vm
                                                                              .displayRate
                                                                              .rate)) /
                                                                          _vm
                                                                            .displayRate
                                                                            .originBaseCharge
                                                                      ) +
                                                                        1 +
                                                                        "% off"
                                                                    : "---"
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.displayRate
                                                          .surcharge
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                            \n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "surcharge"
                                                                    )
                                                                  ) +
                                                                  ": $ " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .displayRate
                                                                      .surcharge ===
                                                                      null
                                                                      ? "----"
                                                                      : _vm
                                                                          .displayRate
                                                                          .surcharge
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.displayRate
                                                          .hasResidentialCheck
                                                          ? _c(
                                                              "small",
                                                              {
                                                                staticStyle: {
                                                                  color: "blue"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      _vm
                                                                        .displayRate
                                                                        .isResidential
                                                                        ? "residential"
                                                                        : "commercial"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.displayRate
                                                          .surcharge
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                            \n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "total"
                                                                    )
                                                                  ) +
                                                                  ": $ " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .displayRate
                                                                      .rate
                                                                      ? _vm.toMoney(
                                                                          _vm
                                                                            .displayRate
                                                                            .rate +
                                                                            _vm
                                                                              .displayRate
                                                                              .surcharge
                                                                        )
                                                                      : "----"
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(
                                                          "\n                           \n                        "
                                                        ),
                                                        _vm.displayRate
                                                          .estimatedDelivery &&
                                                        _vm.displayRate
                                                          .estimatedDelivery !==
                                                          "N/A" &&
                                                        ![
                                                          "xs",
                                                          "sm",
                                                          "md"
                                                        ].includes(
                                                          _vm.$vuetify
                                                            .breakpoint.name
                                                        )
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "estDelivery"
                                                                    )
                                                                  ) +
                                                                  ": " +
                                                                  _vm._s(
                                                                    _vm.formatEstDeliveryDate(
                                                                      _vm
                                                                        .displayRate
                                                                        .estimatedDelivery
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.rates.length > 1 && !_vm.isLoadingRates
                                      ? _c(
                                          "v-flex",
                                          {
                                            staticClass:
                                              "subheading font-weight-bold",
                                            attrs: { md2: "" }
                                          },
                                          [
                                            _c(
                                              "v-menu",
                                              {
                                                attrs: {
                                                  "close-on-content-click": false,
                                                  "nudge-width": 200,
                                                  "offset-x": ""
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        return [
                                                          _c(
                                                            "v-btn",
                                                            _vm._g(
                                                              {
                                                                attrs: {
                                                                  dark: "",
                                                                  color:
                                                                    "primary",
                                                                  flat: ""
                                                                }
                                                              },
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "moreRates"
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  1243220067
                                                ),
                                                model: {
                                                  value: _vm.moreRatesToggle,
                                                  callback: function($$v) {
                                                    _vm.moreRatesToggle = $$v
                                                  },
                                                  expression: "moreRatesToggle"
                                                }
                                              },
                                              [
                                                _vm._v(" "),
                                                _c(
                                                  "v-card",
                                                  [
                                                    _c(
                                                      "v-card-text",
                                                      [
                                                        _c("v-data-table", {
                                                          attrs: {
                                                            headers: [
                                                              {
                                                                text: _vm.$t(
                                                                  "service"
                                                                ),
                                                                align: "left",
                                                                sortable: false,
                                                                value:
                                                                  "serviceType"
                                                              },
                                                              {
                                                                text:
                                                                  _vm.$t(
                                                                    "baseCharge"
                                                                  ) + " ($)",
                                                                align: "left",
                                                                sortable: false,
                                                                value: "rate"
                                                              },
                                                              {
                                                                text:
                                                                  _vm.$t(
                                                                    "surcharge"
                                                                  ) + " ($)",
                                                                align: "left",
                                                                sortable: false,
                                                                value:
                                                                  "surcharge"
                                                              },
                                                              {
                                                                text:
                                                                  _vm.$t(
                                                                    "total"
                                                                  ) + " ($)",
                                                                align: "left",
                                                                sortable: false,
                                                                value: "total"
                                                              },
                                                              {
                                                                text: _vm.$t(
                                                                  "estDelivery"
                                                                ),
                                                                align: "left",
                                                                sortable: false,
                                                                value: ""
                                                              }
                                                            ],
                                                            items: _vm.rates,
                                                            "hide-actions": ""
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "items",
                                                                fn: function(
                                                                  ref
                                                                ) {
                                                                  var item =
                                                                    ref.item
                                                                  return [
                                                                    _c("td", [
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          attrs: {
                                                                            linkify:
                                                                              ""
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.switchMoreRateServiceType(
                                                                                item
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              item.serviceDescription
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      ? [
                                                                          _c(
                                                                            "td",
                                                                            {
                                                                              attrs: {
                                                                                colspan:
                                                                                  "4"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.message
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      : [
                                                                          _c(
                                                                            "td",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.rate
                                                                                )
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "td",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.surcharge
                                                                                )
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "td",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.total
                                                                                )
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "td",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                " +
                                                                                  _vm._s(
                                                                                    _vm.formatEstDeliveryDate(
                                                                                      item.estimatedDelivery
                                                                                    )
                                                                                  ) +
                                                                                  "\n                              "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            false,
                                                            1361963790
                                                          )
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-card-actions",
                                                      [
                                                        _c("v-spacer"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              color: "primary",
                                                              flat: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.moreRatesToggle = false
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("Close")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.errorMessage
                          ? _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass:
                                      "red--text font-weight-bold text-xs-right"
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.errorMessage) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        Object.keys(_vm.warningMessages).length
                          ? _c("v-layout", { attrs: { "justify-end": "" } }, [
                              _c(
                                "span",
                                {
                                  staticClass: "font-weight-bold text-xs-right",
                                  staticStyle: { "background-color": "yellow" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Object.values(_vm.warningMessages).join(
                                          ", "
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-dialog",
              {
                attrs: { fullscreen: "", "full-width": "" },
                model: {
                  value: _vm.isWaitEeiLoading,
                  callback: function($$v) {
                    _vm.isWaitEeiLoading = $$v
                  },
                  expression: "isWaitEeiLoading"
                }
              },
              [
                _c(
                  "v-container",
                  {
                    staticStyle: {
                      "background-color": "rgba(255, 255, 255, 0.75)"
                    },
                    attrs: { fluid: "", "fill-height": "" }
                  },
                  [
                    _c(
                      "v-layout",
                      {
                        attrs: {
                          column: "",
                          "justify-center": "",
                          "align-center": ""
                        }
                      },
                      [
                        _c("v-progress-circular", {
                          attrs: {
                            indeterminate: "",
                            color: "primary",
                            size: "50",
                            width: "5"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "mt-4 text-h6" }, [
                          _vm._v(_vm._s(_vm.$t("pleaseWait30Seconds")))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mt-2 caption" }, [
                          _vm._v(_vm._s(_vm.$t("doNotCloseWindowMessage")))
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "control1",
        fn: function(ref) {
          var loaderButtonError = ref.loaderButtonError
          return [
            _c(
              "LoaderButton",
              {
                staticClass: "ml-3",
                attrs: {
                  buttonText: _vm.$t("submitEEI"),
                  promiseAwait: _vm.showEEIPopup,
                  loading: _vm.isSubmitEEILoading,
                  disabled:
                    _vm.isSubmitEEILoading || _vm.isCommodityUnchangeable
                },
                on: { loaderButtonError: loaderButtonError }
              },
              [
                _c(
                  "template",
                  { slot: "icon" },
                  [
                    _vm.isWaitEeiLoading
                      ? _c(
                          "v-icon",
                          { staticClass: "mx-2 loading", attrs: { dark: "" } },
                          [_vm._v("hourglass_empty")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              2
            )
          ]
        }
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9d25b624", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d25b624","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelCreateInternationalPopup.vue
// module id = null
// module chunks = 